import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { Observable } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TrsVoucherHeader } from "../../models/trs-voucher-header.model";

@Component({
  selector: "ngx-trs-reference-voucher-list",
  templateUrl: "./trs-reference-voucher-list.component.html",
  styleUrls: ["./trs-reference-voucher-list.component.scss"],
})
export class TrsReferenceVoucherListComponent extends BaseFormComponent<TrsVoucherHeader> {
  @Input() VoucherId: number;
  dataList: any[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit() {
    this.getDataList();
    this.setColumns();
    this.formGroup = new UntypedFormGroup({});
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.dataList = undefined;
  }
  canDeactivate(): boolean | Observable<boolean> {
    return true;
  }
  getDataList() {
    this.httpCommonService
      .get(this.apiName + "/?id=" + this.VoucherId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.dataList = data as [];
        },
        (error) => this.getFailedHelper(error)
      );
  }
  async setColumns() {
    this.orignalColumns = [];
    this.columns = [
      {
        name: "RowNumber",
        modelName: "RowNumber",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "ردیف",
        order: 1,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "VoucherKindCode",
        modelName: "VoucherKindCode",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "کد نوع سند",
        order: 2,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "VoucherKindTitle",
        modelName: "VoucherKindTitle",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "نوع سند",
        order: 3,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "VoucherNo",
        modelName: "VoucherNo",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "شماره سند",
        order: 4,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "ShamsiVoucherDate",
        modelName: "ShamsiVoucherDate",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "تاریخ سند",
        order: 5,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "ConcernCode",
        modelName: "ConcernCode",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "َکد بابت",
        order: 6,
        textType: "text",
        withComma: false,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "ConcernTitle",
        modelName: "ConcernTitle",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "بابت",
        order: 7,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "SubLedgerCode",
        modelName: "SubLedgerCode",
        controlType: FormControlTypes.textbox,
        listVisible: false,
        label: "کد معین",
        order: 8,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "SubLedgerTitle",
        modelName: "SubLedgerTitle",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "معین",
        order: 9,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedgerCode",
        modelName: "DetailLedgerCode",
        controlType: FormControlTypes.textbox,
        listVisible: false,
        label: "کد تفصیلی",
        order: 10,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailLedgerTitle",
        modelName: "DetailLedgerTitle",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "تفصیلی طرف مقابل",
        order: 11,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "TreasuryDetailLedgerCode",
        modelName: "TreasuryDetailLedgerCode",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "کد تفصیلی خزانه",
        order: 12,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "TreasuryDetailLedgerTitle",
        modelName: "TreasuryDetailLedgerTitle",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "تفصیلی خزانه",
        order: 13,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "BankTitle",
        modelName: "BankTitle",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "بانک",
        order: 14,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "BankAccountNo",
        modelName: "BankAccountNo",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "حساب بانکی",
        order: 125,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "BankBranchTitle",
        modelName: "BankBranchTitle",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "شعبه",
        order: 16,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DocumentNo",
        modelName: "DocumentNo",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "شماره مدرک",
        order: 17,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "ShamsiDocumentDate",
        modelName: "ShamsiDocumentDate",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "تاریخ مدرک",
        order: 18,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "Price",
        modelName: "Price",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "مبلغ",
        order: 19,
        textType: "number",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
      {
        name: "DetailComment",
        modelName: "DetailComment",
        controlType: FormControlTypes.textbox,
        listVisible: true,
        label: "شرح",
        order: 20,
        textType: "text",
        withComma: true,
        isDecimal: true,
        formVisible: true,
        disabled: false,
        areaName: null,
        systemName: undefined,
        category: undefined,
        DetailControlModels: undefined,
      },
    ];
  }
}
